import { render, staticRenderFns } from "./system.vue?vue&type=template&id=1b579c05&scoped=true&"
var script = {}
import style0 from "./system.vue?vue&type=style&index=0&id=1b579c05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b579c05",
  null
  
)

export default component.exports